interface IPaymentPlanProps {
  children: React.ReactNode;
}

const PaymentPlan: React.FC<IPaymentPlanProps> = ({ children }) => {
  return (
    <span className="tw-lf-body-regular-sm tw-whitespace-pre-line tw-leading-[21px] desktop:tw-lf-body-regular-md desktop:tw-leading-6">
      {children}
    </span>
  );
};

export default PaymentPlan;
